<script lang="ts">
    import Footer from "../../footer/Footer.svelte";
    import Head from "../../header/Head.svelte";
    import Navbar from "../../header/Navbar.svelte";
    import Header from "./Header.svelte";
    import Menu from "./Menu.svelte";
    import { appManager } from "../../AppManagerStore";
    import BasicSettings from "./BasicSettings.svelte";
    import UsersSettings from "./UsersSettings.svelte";
    import type { OrganizationData } from "@anyways-open/identity-api-client";
    import { onMount } from "svelte";

    export let id: string;
    export let view: "general" | "users" = "general";

    let data: OrganizationData;
    let name = "";

    onMount(async () => {
        const accessToken = await $appManager.Authenticator.getAccessToken();
        data = await $appManager.IdentityApi.getOrganization({
            id: id,
            accessToken: accessToken
        });

        name = data.name;
    });
</script>

<Navbar isFluid={false} />

<Header bind:name />

<main class="pb-8 pb-md-11 mt-md-n6">
    <div class="container-md">
        <div class="row">
            <Menu active={view} {id} />

            <div class="col-12 col-md-9">
                <div class="card card-bleed shadow-light-lg mb-6">
                    {#if typeof data !== "undefined"}
                        {#if view === "general"}
                            <BasicSettings {data} />
                        {/if}
                        {#if view === "users"}
                            <UsersSettings {data} />
                        {/if}
                    {/if}
                </div>
            </div>
        </div>
    </div>
</main>

<Footer />
